'use client';
import ActionSheet from '@/components/ActionSheet/indexForPrescription';
import { CollapseArrowDownOutlined } from '@zeelool/icon';
import { useState } from 'react';

interface SelectPopupProps {
  /**
   * 标题
   */
  title: string;
  /**
   * 标题类名
   */
  titleClassName?: string;
  /**
   * 占位符
   */
  placeholder?: string;
  /**
   * 选项
   */
  options: Array<{ label: string; value: string }>;
  /**
   * 保存回调
   */
  onSave: (value: string) => void;
  /**
   * 当前值
   */
  value: string;
  /**
   * 可选：格式化展示值，传入 value 返回展示用字符串；不传则直接展示 value
   */
  formatValue?: (value: string) => string;
  /**
   * 中心选中的值
   */
  centerValue?: string;
  /**
   * 是否禁用
   */
  disabled?: boolean;
  /**
   * 是否显示错误样式
   */
  isError?: boolean;
  /**
   * 打开弹层回调
   */
  onOpen?: () => void;
}

export default function SelectPopup({
  title,
  titleClassName = '',
  placeholder,
  options,
  onSave,
  value,
  formatValue,
  centerValue,
  disabled,
  isError,
  onOpen,
}: SelectPopupProps) {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    if (disabled) return;
    setOpen(true);
    onOpen?.();
  };

  const displayText = formatValue ? formatValue(value) : value;

  return (
    <div
      className={`w-full h-full flex items-center justify-center ${disabled ? 'bg-[#F4F4F4] text-[#808080]' : ''}`}
    >
      <div
        className={`select-box flex items-center justify-center gap-10 p-10`}
        onClick={handleClick}
      >
        <div className={`select-text text-14 font-br text-nowrap ${isError ? 'text-error' : ''}`}>
          {displayText || placeholder}
        </div>
        <CollapseArrowDownOutlined className="text-14 text-gray" />
      </div>

      <ActionSheet
        open={open}
        title={title}
        options={options}
        titleClassName={titleClassName}
        onSave={onSave}
        onClose={() => setOpen(false)}
        defaultValue={centerValue}
        value={value}
      />
    </div>
  );
}
